import React from 'react';
import classNames from 'classnames';

import CroppedImage from 'rebook/apps/utils/components/CroppedImage';

import styles from './style.scss';


const StackBookCover = ({ audioBooks, textBooks }) => {
  return (
    <div className={styles.wrapper}>
      {audioBooks && audioBooks.map((image) => (
        <CroppedImage
          className={classNames(styles.image, styles.audioBook)}
          src={image}
          alt={'image'}
          height={130}
          width={130}
          key={image} />
      ))}
      {textBooks && textBooks.map((image) => (
        <CroppedImage
          className={styles.image}
          src={image}
          alt={'image'}
          height={130}
          width={80}
          key={image} />
      ))}
    </div>
  );
};

export default StackBookCover;
